import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { AdminGridComponent, GridColumn } from 'src/app/components/layout/admin-grid/admin-grid.component';

import { AccountService } from 'src/app/services/account.service';
import { Site } from 'src/app/models/site.model';
import { Account } from 'src/app/models/account.model';
import { SiteService } from 'src/app/services/site.services';

@Component({
  selector: 'app-site-manager',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminGridComponent],
  templateUrl: './site-manager.component.html',
  styleUrls: ['./site-manager.component.scss']
})
export class SiteManagerComponent implements OnInit {
  user = {
    picture: '/assets/images/avatar.png',
    nickname: 'Client',
    email: 'client@bouncd.com'
  };

  sites: Site[] = [];
  loading = false;

  columns: GridColumn[] = [
    { field: 'name', header: 'Site Name', sortable: true },
    { field: 'domain', header: 'Domain', sortable: true },
    { field: 'environment', header: 'Environment', sortable: true },
    { field: 'active', header: 'Status', sortable: true }
  ];

  constructor(
    private siteService: SiteService,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.loadSites();
  }

  get activeSiteCount(): number {
    return this.sites.filter(s => s.active).length;
  }

  /** Load all sites */
  loadSites(): void {
    this.loading = true;
    this.siteService.getAll().subscribe({
      next: (data) => {
        this.sites = data.sort((a, b) => a.name.localeCompare(b.name));
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load sites:', err);
        this.loading = false;
      }
    });
  }

  /** Dynamically load lookup data (accounts) */
  async loadSiteLookups(row: any): Promise<Record<string, any[]>> {
    const accounts = await firstValueFrom(this.accountService.getAll());
    return {
      accountList: accounts.map((a: Account) => ({
        label: a.name,
        value: a.id
      })),
    };
  }

  /** Create a new site */
  addSite(): void {
    const newSite: Site = {
      id: crypto.randomUUID(),
      name: 'New Site',
      domain: 'newsite.example.com',
      environment: 'dev',
      active: true,
      createdAt: new Date().toISOString(),
      accountId: 'acct_demo'
    };

    this.siteService.create(newSite).subscribe({
      next: () => this.loadSites(),
      error: (err) => console.error('Failed to add site:', err)
    });
  }

  /** Update an existing site */
  editSite(row: Site): void {
    const updated = { ...row, name: `${row.name} (Updated)` };
    this.siteService.update(row.id, updated).subscribe({
      next: () => this.loadSites(),
      error: (err) => console.error('Failed to update site:', err)
    });
  }

  /** Delete a site */
  deleteSite(row: Site): void {
    if (!confirm(`Delete site "${row.name}"?`)) return;
    this.siteService.delete(row.id).subscribe({
      next: () => this.loadSites(),
      error: (err) => console.error('Failed to delete site:', err)
    });
  }
}
